<template>
  <section class="section_panel packages_section">
    <h5 class="section_title">
      <i class="fal fa-box-open"></i>
      {{ $t("TITLES.packages_list") }}
      <span class="count_badge">{{ packages.length }}</span>
    </h5>

    <v-row v-if="packages.length" class="packages_row">
      <bundle-package-card
        v-for="(pkg, index) in packages"
        :key="pkg.id"
        :pkg="pkg"
        :index="index"
        @show-qr="(qr, num) => $emit('show-qr', qr, num)"
        @show-details="(pkg) => $emit('show-details', pkg)"
        @view-invoice="(pkg) => $emit('view-invoice', pkg)"
      />
    </v-row>

    <div v-else class="empty_state">
      <i class="fal fa-box empty_state__icon"></i>
      <p class="mt-3">{{ $t("MESSAGES.no_packages") }}</p>
    </div>
  </section>
</template>

<script>
import BundlePackageCard from "./BundlePackageCard.vue";

export default {
  name: "BundlePackagesSection",

  components: {
    BundlePackageCard,
  },

  props: {
    packages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
